import { useInfiniteQueryUniversalSearch } from '@/features/shop/services/UniversalCategories/queries'
import { Headline } from '@shipt/design-system-typography'
import styled from 'styled-components'
import { SkeletonProvider } from '@/features/shared/components/SkeletonLoader'
import { UngatedInfiniteProductGrid } from '@/features/shop/components/UngatedCategoryPage/UngatedProductGrid'
import { Box } from '@shipt/design-system-layouts'

type Props = {
  currentProductUniversalId: string
  categoryId: number
  categoryName?: string
}

export const UngatedProductSimilarItems = ({
  currentProductUniversalId,
  categoryId,
  categoryName,
}: Props) => {
  const { isFetching, data: productData } = useInfiniteQueryUniversalSearch({
    category_id: categoryId,
  })

  const totalProductCount = productData?.pages[0]?.total_hits ?? 0

  if (!totalProductCount) {
    return
  }

  return (
    <Box margin={['xl', 0, 'lg']}>
      <SimilarItemsTitle as="h2" size="lg">
        Shop {categoryName}
      </SimilarItemsTitle>
      <SkeletonProvider isLoading={isFetching}>
        <UngatedInfiniteProductGrid
          data={{
            pages: [
              {
                products:
                  productData?.pages[0]?.products
                    ?.filter((product) => product.universal_id !== currentProductUniversalId)
                    .slice(0, 12) ?? [],
              },
            ],
            pageParams: [],
          }}
        />
      </SkeletonProvider>
    </Box>
  )
}

const SimilarItemsTitle = styled(Headline)`
  margin-top: 1rem;
  margin-bottom: 3rem;
`
